import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";
import UserTab from "./UserTab";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
export default function MatchingLenders() {
    const params = useParams();
    const [loading, setLoading] = useState(false);
    const [errorStatus, setErrorStatus] = useState("");
    const [status, setStatus] = useState("");
    const [lenders, setLenders] = useState([]);
    const [loadingStates, setLoadingStates] = useState({}); // Track applying state for each lender
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [customSubject, setCustomSubject] = useState("");
    const [emailContent, setEmailContent] = useState('');
    const [selectedEmails, setSelectedEmails] = useState(null);
    const [emails, setEmails] = useState([]);
    const [ccEmails, setCCEmails] = useState([]);
    const [templates, setTemplates] = useState([]);
    const [templateSubject, setTemplateSubject] = useState("");
    const handleEmailTemplate = (e) => {
        e.preventDefault();
        if (e.target.value !== "custom") {
            const selectedRecord = templates.find(record => record.userTemplateId === e.target.value);
            setCustomSubject(selectedRecord.subject);
            setEmailContent(selectedRecord.content);
        }
        else{
            setCustomSubject("");
            setEmailContent("");
        }
        setTemplateSubject(e.target.value);
    }
    const GetTemplates = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETUSERTEMPLATES + "?UserId=" + localStorage.getItem("userId"), { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setTemplates(response.data.data?.data);
                }
            });
    };
    const handleOpenEmailModal = () => {
        setShowEmailModal(true);
    };
    const handleCloseEmailModal = () => {
        setShowEmailModal(false);
        resetForm();
    };
    const handleEmailChange = (options) => {
        const values = options.map(option => option.value);
        setSelectedEmails(options);
        setCCEmails(values);
    };
    const GetClientEmails = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETCLIENTEMAILS + "?ClientId=" + localStorage.getItem('clientId') + "&pageNumber=1&pageSize=100", { ...headerconfig })
            .then((response) => {
                console.log(response.data);
                if (response.data.statusCode === 200) {
                    var colourOptions = response.data.data.data;
                    const options = colourOptions.map(item => ({
                        value: item.email,
                        label: item.email
                    }));
                    setEmails(options);
                }
            });
    };
    const handleCheckboxChange = (id) => {
        setSelectedRows(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
        );
    };
    const handleSelectAllChange = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            const allIds = lenders.map(l => l.lenderId);
            setSelectedRows(allIds);
        } else {
            setSelectedRows([]);
        }
    };
    const handleApplyAll = async () => {
        setShowEmailModal(true);
        //const selectedData = lenders.filter(l => l.status === "MATCHING").map(l => l.lenderId);        
    };
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    }
    const handleSendEmail = async () => {
        if (!customSubject || !emailContent) {
            handleError("Please fill in all required fields");
            return;
        }
        else {
            const selectedData = lenders.filter(l => selectedRows.includes(l.lenderId));
            // You can now process selectedData or send to API
            try {
                if (selectedData.length > 0) {
                    await Promise.all(selectedData.map(lender => InsertData(lender)));
                    handleSuccess("All selected lenders applied successfully.");
                }
            } catch (error) {
                handleError("One or more insert operations failed:", error);
            }
        }
    };
    const handleSubmit = (e, data) => {
        e.preventDefault();
        setLoadingStates((prev) => ({ ...prev, [data.lenderId]: true }));
        InsertData(data);
        setShowEmailModal(true);
        handleSuccess("Application successfully applied");
    };
    const InsertData = (data) => {
        var formData = new FormData()
        formData.append("applicationLenderId", data.applicationLenderId);
        formData.append("lendingApplicationId", data.lendingApplicationId);
        formData.append("lenderId", data.lenderId);
        formData.append("userId", localStorage.getItem('userId'));
        formData.append("status", data.status === "MATCHING" ? "APPLY" : data.status);
        formData.append("domainurl", window.location.origin);
        formData.append("amount", 0);
        formData.append("loanAmount", 0);
        formData.append("rate", 0);
        formData.append("paybackAmount", 0);
        formData.append("paymentAmount", 0);
        formData.append("paymentFrequency", 0);
        formData.append("numberOfPayments", 0);
        formData.append("commissionPoints", 0);
        formData.append("commission", 0);
        formData.append("reason", "");
        formData.append("emailType", "CUSTOM");
        formData.append("emailSubject", customSubject);
        formData.append("emailBody", customSubject);
        formData.append("emailSubject", emailContent);
        formData.append("ccEmails", ccEmails);
        console.log(ccEmails);
        addOrEdit(formData, data);
        setShowEmailModal(false);
        resetForm();
    }

    const applicationAPI = () => {
        return {
            update: (updateRecord) =>
                axios.put(config.APIACTIVATEURL + config.UPDATEAPPLICATIONLENDER, updateRecord, { ...headerconfig })
        };
    };
    const resetForm = () => {
        setEmailContent("");
    }
    const addOrEdit = (formData, data) => {
        applicationAPI()
            .update(formData)
            .then((res) => {
                if (res.data.statusCode === 200) {
                    GetMatchingLenders();
                    setLoadingStates((prev) => ({ ...prev, [data.lenderId]: false }));
                }
                else {
                    handleError(res.data.message);
                }
            })
            .catch(function (error) {
                handleError("Error in updating data");
            });

    };
    const handleOffers = () => {
        //e.preventDefault();
        setLoading(true);
        axios.post(config.APIACTIVATEURL + config.APPLICATIONLENDERMULTI + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLoading(false);
                    GetMatchingLenders();
                    handleSuccess("Congratulations matching funders found for your application");
                    setErrorStatus("");
                }
                else {
                    setLoading(false);
                    setStatus("");
                    setErrorStatus(response.data.message);
                }
            });
    };
    const GetMatchingLenders = () => {
        axios
            .get(config.APIACTIVATEURL + config.GETAPPLICATIONLENDERBYAPPLICATION + "/" + params.lendingApplicationId, { ...headerconfig })
            .then((response) => {
                if (response.data.statusCode === 200) {
                    setLenders(response.data.data.data);
                    setLoading(false);
                }
                else {
                    setLoading(false);
                }
            });
    };
    useEffect(() => {
        handleOffers();
        GetClientEmails();
        GetTemplates();
    }, [])
    return (
        <div id="layout-wrapper">
            <Header></Header>
            <SideBar></SideBar>
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div class="card card-body py-3">
                        <UserTab pagename="lenders"></UserTab>
                    </div>
                    <div class="card card-body py-3">
                        <div className="d-flex align-items-center mb-4">
                            {/* {loading === true ?
                                <button className="btn btn-secondary" type="button" disabled>Checking...</button>
                                :
                                <button className="btn btn-secondary" onClick={handleOffers} type="button">Check Matching Lenders</button>
                            } */}
                            {selectedRows.length > 0 && (
                                <div className="mt-3">
                                    <button className="btn btn-success" onClick={handleApplyAll}>
                                        Apply
                                    </button>
                                </div>
                            )}

                        </div>
                        {loading === false ?
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="table-responsive">
                                        {lenders.length > 0 ?
                                            <>
                                                <h5 className="card-title flex-grow-1 mb-2">
                                                    <span className="badge text-bg-success">{status}</span>
                                                </h5>
                                                <table className="table table-borderless align-middle mb-0">
                                                    <thead className="table-light">
                                                        <tr className="text-left">
                                                            <th>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={selectAll}
                                                                    onChange={handleSelectAllChange}
                                                                />
                                                            </th>
                                                            <th scope="col">Funder</th>
                                                            <th scope="col">Email</th>
                                                            <th scope="col">Addditional Information</th>
                                                            <th scope="col">Status</th>
                                                            <th scope="col">Reason</th>
                                                            <th scope="col">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="text-left">
                                                        {lenders.map(d =>
                                                            <tr>
                                                                <td>
                                                                    {d.status === "MATCHING" ? (
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={selectedRows.includes(d.lenderId)}
                                                                            onChange={() => handleCheckboxChange(d.lenderId)}
                                                                        />) :
                                                                        (<input type="checkbox" disabled checked={true} />)
                                                                    }
                                                                </td>

                                                                <td>{d.companyName}</td>
                                                                <td>
                                                                    {d.email.split(',').map((email, index) => (
                                                                        <div key={index}>{email.trim()}</div>
                                                                    ))}
                                                                </td>
                                                                <td>{d.lenderDescription}</td>
                                                                <td>{
                                                                    d.status === "MATCHING" ? <span className="badge text-bg-warning">NOT YET APPLIED</span> :
                                                                        d.status === "APPLY" ? <span className="badge text-bg-primary">APPLIED</span> :
                                                                            d.status === "REJECTED" ? <span className="badge text-bg-danger">REJECTED</span> :
                                                                                d.status === "APPROVED" ? <span className="badge text-bg-success">APPROVED</span> : d.status}
                                                                </td>
                                                                <td>{d.reason}</td>
                                                                <td>{d.status === "APPROVED" ?
                                                                    (<Link to={"/userdashboard/offers/" + d.lendingApplicationId} className="btn btn-sm btn-primary">VIEW OFFER</Link>)
                                                                    :
                                                                    ("")}
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </>
                                            :
                                            <table className="table table-borderless align-middle mb-0">
                                                <tbody>
                                                    <tr>
                                                        <td colSpan={6} className="text-center">
                                                            <span className="badge text-bg-danger">No matching funders found. Please upload documents</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>}
                                    </div>
                                </div>
                            </div>
                            :
                            <div className="mb-3">
                                <img src="/assets/images/uploadloading.gif" width="60px" height="60px"></img>Checking Matching Funders
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Modal show={showEmailModal} onHide={handleCloseEmailModal}>
                <Modal.Header>
                    <Modal.Title>Email</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-lg-12 mb-3">
                            <label htmlFor="subject" className="form-label">Template</label>
                            <select className="form-select mb-2" value={templateSubject} onChange={handleEmailTemplate}>
                                <option value="custom">Add Custom Email</option>
                                {templates.length > 0 && templates.map(t =>
                                    <option value={t.userTemplateId}>{t.subject}</option>
                                )}
                            </select>
                        </div>
                        {/* Show content textarea only for custom subjects */}
                        <div className="col-lg-12 mb-3">
                            <label className="form-label">Subject</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Type your subject here"
                                value={customSubject}
                                onChange={(e) => setCustomSubject(e.target.value)}
                                required
                            />
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label htmlFor="emailContent" className="form-label">Email Content</label>
                            <textarea
                                value={emailContent}
                                onChange={(e) => setEmailContent(e.target.value)}
                                className="form-control"
                                rows="5"
                                placeholder="Enter your email content here..."
                                required
                            />
                        </div>
                        <div className="col-lg-12 mb-3">
                            <label className="form-label">CC Emails</label>
                            <Select isMulti name="ccEmails" options={emails} className="basic-multi-select" classNamePrefix="select restricted states" onChange={handleEmailChange} value={selectedEmails} />
                        </div>
                        <Modal.Footer>
                            <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                                {
                                    loading === false ?
                                        <button
                                            type="button"
                                            onClick={handleSendEmail}
                                            className="btn btn-primary"
                                            disabled={!customSubject || !emailContent}
                                        >
                                            Send Email
                                        </button>
                                        :
                                        <button type="button" className="btn btn-primary" disabled>
                                            Sending...
                                        </button>
                                }
                                <button type="button" className="btn btn-danger" onClick={handleCloseEmailModal}>
                                    Cancel
                                </button>
                            </div>
                        </Modal.Footer>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}